import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import api from "../../api/api";
import logo from "../../assets/images/Logo smart farm1.jpg";
import Background from "../../assets/images/background-signup.png";

const languages = {
  ar: { label: "AR", flag: "TN" },
  fr: { label: "FR", flag: "FR" },
  en: { label: "EN", flag: "GB" },
  it: { label: "IT", flag: "IT" },
  wf: { label: "WF", flag: "SN" },
};

const ForgotPwd = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [local, setLocal] = useState(localStorage.getItem("local") || "en");
  const { t, i18n } = useTranslation();

  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("local", lang);
    setLocal(lang);
  };

  const validate = () => {
    if (!email.trim()) {
      setEmailError(t("email_cannot_be_blank"));
      return false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setEmailError(t("incorrect_email_format"));
      return false;
    }

    setEmailError("");
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const response = await api.post("/forgot-password", { email });
      if (response.data.type === "success") {
        setIsSent(true);
        setEmail("");
        swal({
          icon: "success",
          title: t("ok"),
          text: t("email_sent_change_password"),
        });
      }
    } catch (error) {
      swal({
        icon: "error",
        title: t("Oops..."),
        text: t("Error"),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page auth-forgot-page">
      <div className="auth-shell auth-shell-compact">
        <section className="auth-visual" style={{ backgroundImage: `url(${Background})` }}>
          <div className="auth-visual-shade" />
          <Link to="/" className="auth-brand" aria-label="SmartFarm">
            <img src={logo} alt="SmartFarm" />
          </Link>
          <div className="auth-visual-content">
            <span className="auth-eyebrow">SMARTFARM</span>
            <h1>{t("forgot_pwd?")}</h1>
            <p>{t("forgot_pwd")}</p>
            <div className="auth-reset-steps">
              <span><strong>1</strong>{t("email")}</span>
              <i className="fas fa-arrow-right" />
              <span><strong>2</strong>{t("reset_link_btn")}</span>
              <i className="fas fa-arrow-right" />
              <span><strong>3</strong>{t("Password")}</span>
            </div>
          </div>
          <div className="auth-visual-footer">
            <i className="fas fa-shield-alt" />
            <span>Procédure simple et sécurisée</span>
          </div>
        </section>

        <section className="auth-form-panel">
          <div className="auth-form-topbar">
            <Link to="/" className="auth-back-link"><i className="fas fa-arrow-left" /> {t("sign_in")}</Link>
            <Dropdown align="end" className="auth-language">
              <Dropdown.Toggle variant="light" id="forgot-language">
                <ReactCountryFlag countryCode={languages[local].flag} svg />
                <span>{languages[local].label}</span>
                <i className="fas fa-chevron-down" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {Object.entries(languages).map(([lang, language]) => (
                  <Dropdown.Item key={lang} active={local === lang} onClick={() => changeLanguageHandler(lang)}>
                    <ReactCountryFlag countryCode={language.flag} svg />
                    <span>{language.label}</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="auth-form-content auth-reset-content">
            <div className="auth-form-heading">
              <span className="auth-heading-icon"><i className="fas fa-key" /></span>
              <div>
                <span className="auth-eyebrow">SMARTFARM</span>
                <h2>{t("forgot_pwd?")}</h2>
                <p>{t("forgot_pwd")}</p>
              </div>
            </div>

            {isSent && (
              <div className="auth-success" role="status">
                <i className="fas fa-check-circle" />
                <div><strong>{t("ok")}</strong><span>{t("email_sent_change_password")}</span></div>
              </div>
            )}

            <form className="auth-form" onSubmit={handleSubmit} noValidate>
              <label className="auth-field">
                <span>{t("email")}</span>
                <div className={`auth-input-wrap ${emailError ? "is-invalid" : ""}`}>
                  <i className="far fa-envelope" />
                  <input
                    type="email"
                    value={email}
                    placeholder="name@example.com"
                    autoComplete="email"
                    onChange={(event) => {
                      setEmail(event.target.value);
                      if (emailError) setEmailError("");
                    }}
                  />
                </div>
                {emailError && <small className="auth-field-error"><i className="fas fa-exclamation-circle" />{emailError}</small>}
              </label>

              <button type="submit" className="auth-primary-button" disabled={isSubmitting}>
                {isSubmitting ? <i className="fas fa-circle-notch fa-spin" /> : <i className="far fa-paper-plane" />}
                <span>{t("reset_link_btn")}</span>
              </button>
            </form>

            <p className="auth-help-text">
              <i className="fas fa-info-circle" />
              Vérifiez également votre dossier de courrier indésirable après l’envoi.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ForgotPwd;
